RivalIQ.apps.Discovery.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.ensureChannelToken = function (curation) {
        let channelName = curation.getProp('channel');
        let displaySource;

        if (channelName !== RivalIQ.enums.channels.INSTAGRAM) {
            return;
        } else {
            // we need to access the fb api to get ig data
            displaySource = RivalIQ.data.channels.get(RivalIQ.enums.channels.INSTAGRAM).get('source');
            channelName = RivalIQ.enums.channels.FACEBOOK;
        }

        return App.data.tokenCoverage.fetch().then(function (tokenCoverage) {
            const channel = RivalIQ.data.channels.get(channelName);
            const source = channel.get('source');

            if (!_.get(tokenCoverage[source], 'validToken')) {
                if (curation.isExporting()) {
                    RivalIQ.export.failExport('no valid token found');
                }

                curation.setProps('channelRedacted', true, {
                    silent: true
                });
                return new RivalIQ.apps.Discovery.views.ChannelWall({
                    source: source,
                    displaySource: displaySource,
                    isExport: curation.isExporting(),
                    dashboardModel: curation
                });
            } else {
                curation.setProps('channelRedacted', null, {
                    silent: true
                });
            }
        });
    };
});
